if (!customElements.get('swatch-group')) {
  customElements.define(
    'swatch-group',
    class SwatchGroup extends HTMLElement {
      connectedCallback() {
        this.moreButton = this.querySelector('[data-swatch-more]');
        if (!this.moreButton) return;
        this.expanded = false;
        this.count = this.moreButton.dataset.count;
        this.labelMore = this.moreButton.dataset.labelMore;
        this.labelLess = this.moreButton.dataset.labelLess;
        this.moreButton.addEventListener('click', this.toggle.bind(this));
      }

      toggle() {
        this.expanded = !this.expanded;
        this.querySelectorAll('[data-swatch-hidden]').forEach((swatch) => {
          swatch.hidden = !this.expanded;
        });
        this.moreButton.textContent = this.expanded ? `-${this.count}` : `+${this.count}`;
        this.moreButton.setAttribute('aria-expanded', this.expanded);
        this.moreButton.setAttribute('aria-label', this.expanded ? this.labelLess : this.labelMore);
      }
    }
  );
}
